// ==================== ProductReviewsSection.jsx ====================
import React, { useEffect, useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import api from "../../api"

const StarRating = ({ value }) => {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star}>
          {star <= value ? (
            <FaStar className="text-[#FFC107]" />
          ) : (
            <FaRegStar className="text-gray-300" />
          )}
        </span>
      ))}
    </div>
  );
};

const ProductReviewsSection = ({ productId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!productId) return;

    const fetchReviews = async () => {
      try {
        setLoading(true);
        const res = await api(`/information/products/${productId}/reviews/`);
        setData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [productId]);

  if (loading) {
    return <div className="p-4 text-center text-sm text-gray-500">در حال دریافت نظرات...</div>;
  }

  if (!data) {
    return <div className="p-4 text-center text-sm text-gray-500">نظری یافت نشد.</div>;
  }

  if (data.reviews.length === 0) {
    return (
      <div className="p-4 text-center text-sm text-gray-500 bg-gray-50 rounded-2xl border border-gray-200">
        هنوز نظری ثبت نشده است.
      </div>
    );
  }

  return (
    <div className="space-y-6 md:space-y-8 rtl">
      <div className="text-center bg-gray-50 rounded-2xl border border-gray-200 py-4">
        <div className="text-base md:text-lg font-bold text-gray-900">
          میانگین وزنی امتیاز کالا: {data.average_rating} از 5
        </div>
        <div className="text-xs md:text-sm text-gray-500 mt-1">
          در بین {data.reviews_count} نظر
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        <div>
          <h3 className="font-semibold text-sm md:text-base text-gray-900 mb-4">بازخوردهای مثبت</h3>
          <div className="space-y-3">
            {data.positive_feedbacks.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <div className="w-24 md:w-28 shrink-0 text-xs md:text-sm text-gray-700 truncate">{item.title}</div>
                <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#00AFA9] rounded-full"
                    style={{ width: `${Math.min(item.count, 100)}%` }}
                  />
                </div>
                <div className="w-8 shrink-0 text-left text-xs md:text-sm text-gray-600">{item.count}</div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-semibold text-sm md:text-base text-gray-900 mb-4">بازخوردهای منفی</h3>
          <div className="space-y-3">
            {data.negative_feedbacks.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <div className="w-24 md:w-28 shrink-0 text-xs md:text-sm text-gray-700 truncate">{item.title}</div>
                <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#E74C3C] rounded-full"
                    style={{ width: `${Math.min(item.count, 100)}%` }}
                  />
                </div>
                <div className="w-8 shrink-0 text-left text-xs md:text-sm text-gray-600">{item.count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="space-y-5 md:space-y-6">
        {data.reviews.map((review) => (
          <div key={review.id} className="border-t border-gray-100 pt-5 md:pt-6">
            <div className="flex items-center gap-3 mb-3 md:mb-4">
              <img
                src={review.displayed_user?.avatar || "/default-avatar.png"}
                alt=""
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border border-gray-200"
              />
              <div className="min-w-0">
                <div className="font-medium text-sm md:text-base text-gray-900 truncate">
                  {review.displayed_user?.full_name}
                </div>
                <div className="text-xs text-gray-400">
                  {new Date(review.created_at).toLocaleDateString("fa-IR")}
                </div>
              </div>
              <div className="mr-auto shrink-0">
                <StarRating value={review.rating} />
              </div>
            </div>

            {review.comment && (
              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-sm text-gray-700 leading-relaxed">
                {review.comment}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductReviewsSection;